var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-row"},_vm._l((_vm.GPUs),function(tr,index){return _c('div',{key:index,staticClass:"vx-col xl:w-1/2 w-full mt-6"},[_c('single-g-p-u-card',{attrs:{"g-p-u":tr}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }